
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.703 11.223c-3.7-.8-5.7.8-9 1.5-3.1.7-6.5-2-10-1.7-5.1.5-9.3 4.2-10.9 9-2.8 8.4 2.2 13.9 7.7 19.2l9.3 9c1.5 1.4 2.2 2.4 4.2 1.2 3.3-1.9 6.3-6.1 9-8.7 2.1-2.1 4.6-4 6.5-6.3 6.3-7.6 3.9-20.8-6.8-23.2zm-3.5 29.9c-1.6 1.6-3.4 4.1-5.4 5.2-1.9 1.1-2.5-.1-4-1.5-4-3.9-8.1-7.8-12.1-11.7-10.7-10.5 3.2-24.3 14.7-16.5.1.1.2.1.4 0 9.9-6.7 25.5 3.4 16.1 15.1-2.9 3.4-6.5 6.3-9.7 9.4z"}}),_c('path',{attrs:{"d":"M47.303 24.923c-.1-5.4-3.7-10-9.3-10.2-1 0-1 3.1 0 3.2 3.9.1 7.8 2.9 7.9 7 0 .4.1 1.6.7 1.6s.7-1.2.7-1.6z"}})])
          )
        }
      }
    